import { jsx as k } from "react/jsx-runtime";
import S from "../../ui-kit/theme-button.mjs";
import { BadRequest as b } from "@systemeio/util";
import { useLoadPaypalScript as B } from "./use-load-paypal-script.mjs";
import { useStore as F } from "../../store/index.mjs";
import { useBuyOffer as O } from "../../pages/checkout/api/index.mjs";
function j({
  isFetching: p,
  buttonTitle: s,
  buttonDisabled: u,
  setIsFetching: t,
  preSubmit: f,
  handleBadRequest: w
}) {
  const { locale: m } = F(), { isScriptLoading: y } = B(), { buyOffer: d } = O();
  return /* @__PURE__ */ k(
    S,
    {
      onClick: async (h) => {
        var e, r, a, i, n;
        h.preventDefault(), t(!0);
        try {
          const o = f();
          if (!o) return;
          (e = window.paypal) == null || e.checkout.initXO();
          const { redirect: c, approvalUrl: l } = await d(o, m);
          if (!l) {
            (r = window.paypal) == null || r.checkout.closeFlow(), c && window.location.assign(c);
            return;
          }
          (a = window.paypal) == null || a.checkout.startFlow(l);
        } catch (o) {
          if (o instanceof b)
            w(o), (i = window.paypal) == null || i.checkout.closeFlow();
          else
            throw (n = window.paypal) == null || n.checkout.closeFlow(), o;
        } finally {
          t(!1);
        }
      },
      isFetching: p,
      disabled: y || u,
      type: "submit",
      children: s
    }
  );
}
export {
  j as PaypalSoapPaymentButton
};
